<template>
    <div class="p-5">
        <div class="grid grid-cols-3 gap-4 text-center">
            <router-link to="/" exact active-class="text-white bg-[#1865b1]"
                class="p-2 border-2 border-slate-300 rounded-md font-bold hover:text-[#fecc4f] hover:border-[#1865b1] hover:bg-[#1865b1]">
                Sổ thu chi
            </router-link>
            <router-link to="/periodic" exact active-class="text-white bg-[#1865b1]"
                class="p-2 border-2 border-slate-300 rounded-md font-bold hover:text-[#fecc4f] hover:border-[#1865b1] hover:bg-[#1865b1]">
                Khoản thu chi định kỳ
            </router-link>
            <router-link to="/tools" exact active-class="text-white bg-[#1865b1]"
                class="p-2 border-2 border-slate-300 rounded-md font-bold hover:text-[#fecc4f] hover:border-[#1865b1] hover:bg-[#1865b1]">
                Công cụ
            </router-link>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>